// src/state/loggedInUser/types.ts
var SET_INITIAL_LOGGED_IN_USER = "SET_INITIAL_LOGGED_IN_USER";
var SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
var SET_LOGGED_IN_ROLE_ON_STATE = "SET_LOGGED_IN_ROLE_ON_STATE";
var SET_MENU_ACCESS_LOCATIONS = "SET_MENU_ACCESS_LOCATIONS";
var SET_SETTINGS_ACCESS_LOCATIONS = "SET_SETTINGS_ACCESS_LOCATIONS";
var CLEAR_LOGGED_IN_USER = "CLEAR_LOGGED_IN_USER";

export { CLEAR_LOGGED_IN_USER, SET_INITIAL_LOGGED_IN_USER, SET_LOGGED_IN_ROLE_ON_STATE, SET_LOGGED_IN_USER, SET_MENU_ACCESS_LOCATIONS, SET_SETTINGS_ACCESS_LOCATIONS };
